//
//
//
//
//
//
//
//
//


import tools from '@/plugin/tools'
var agentId = '1000038'
export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      load: false
    }
  },
  watch: {
    '$route': function () {
      this.$store.commit('meetDetailTag', false)
      this.$store.commit('roomDetailTag', false)
      this.$vux.confirm.hide()
    }
  },
  methods: {
    // 调用企业微信sdk
    getTicket: function () {
      this.load = true
      let that = this
      let preData = {
        iv: this.$decryption.iv(16),
        agentId: agentId,
        url: window.location.href.split('#/')[0]
      }
      this.$api.send({
        url: 'user.getTicket',
        params: preData,
        success: function (res) {
          let validation = JSON.parse(that.$decryption.decrypt(preData.iv, res))
          wx.config({
            beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: 'wwfc35391257eb7ea4', // 必填，企业微信的corpID
            timestamp: validation.timestamp, // 必填，生成签名的时间戳
            nonceStr: validation.noncestr, // 必填，生成签名的随机串
            signature: validation.signature,// 必填，签名，见附录1
            jsApiList: ['onHistoryBack'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
            console.log('成功')
            wx.hideOptionMenu()
          });
          wx.error(function (res) {
            console.log('失败 ')
          });
        }
      })
    },
    IsPC: function () {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
      let flag = true;
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  created () {
    this.$store.commit('setPc', this.IsPC())
    // localStorage.clear()
    let timeFlag = new Date().getTime()
    let lastTime = localStorage.getItem('timeFlag')
    let interval = 0
    if (!lastTime) {
      localStorage.clear()
      console.log('首次清除')
    } else {
      interval = (timeFlag - lastTime)
    }
    // 2 * 60 * 60 * 1000
    if (interval > 7200000) {
      localStorage.clear()
      console.log('超时清除')
    }
    let that = this
    let jsDada = localStorage.getItem('userPermissions')
    // let url = 'https://qyapi.weixin.qq.com/cgi-bin/gettoken'
    let data = {
      'agentid': agentId,
      'code': tools.GetQueryString('code')
    }
    let iv = this.$decryption.iv(16)
    // 缓存没有
    if (!jsDada) {
      console.log('请求')
      if (tools.GetQueryString('code')) {
        this.$api.send({
          url: 'user.getToken',
          params: {
            'data': data,
            'iv': iv
          },
          success: function (res) {
            console.log('成功了')
            console.log(res)
            let jsDada = that.$decryption.decrypt(iv, res)
            localStorage.setItem('userPermissions', jsDada)
            localStorage.setItem('timeFlag', timeFlag)
            that.resData = JSON.parse(jsDada)
            let token = that.resData.token
            that.$api.setAccessToken(token)
            that.$store.commit('setUserInfo', that.resData)
            that.isGeting = false
            that.getTicket()
          },
          exception: function () {
            alert('获取授权异常')
          },
          fail: function (e) {
            console.log('发生错误', e.errorMsg)
            alert('获取授权错误' + e.errorMsg)
          }
        })
      } else {
        console.log(this)
        this.$vux.alert.show({
          content: '授权失效，请重新授权',
          type: 'text',
          width: '3rem'
        })
        this.load = true
      }
    } else {
      // 取缓存
      this.resData = JSON.parse(jsDada)
      this.$api.setAccessToken(this.resData.token)
      that.$store.commit('setUserInfo', that.resData)
      // this.getTicket()
      this.isGeting = false
      that.getTicket()
      /*setTimeout(function () {
        that.isGeting = false
      }, 1000)*/
      // this.$router.push({path:'/list'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue